import * as CSS from "csstype"
import { system } from "styled-system"

const transform = system({
  transform: true,
})

export interface TransformProps {
  transform?: CSS.Property.Transform | CSS.Property.Transform[]
}

export default transform
